module.exports = __webpack_public_path__ + "img/icon_rotate_180.365dc1bb.svg";